import { Component, createRef } from 'react';
import { NSBoxString } from './NSBoxString';
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { NSRow } from './NSRow';

export interface NSTagProps extends IBaseComponentProps
{
	onChanged?: (e: NSBoxString, callback?: () => void) => void;
	onDeleted?: () => void;
}
export interface NSTagValue
{
	name: string;
	value: string;
}

export class NSTag extends Component<NSTagProps>
{
	static isEmpty(value: NSTagValue | null)
	{
		if (value)
			if (value.name || value.value)
				return false
		return true;
	}

	private NSBoxString_Key = createRef<NSBoxString>();
	private NSBoxString_Value = createRef<NSBoxString>();

	getValue(checkError: boolean = true): NSTagValue
	{
		let name = this.NSBoxString_Key.current?.getValue(checkError) ?? "";
		let value = this.NSBoxString_Value.current?.getValue(checkError) ?? "";
		return {
			name,
			value
		};
	}
	setValue(value: NSTagValue | null, callback?: () => void)
	{
		this.NSBoxString_Key.current?.setValue(value?.name ?? "", callback);
		this.NSBoxString_Value.current?.setValue(value?.value ?? "", callback);
	}
	override render()
	{
		return (
			<NSRow
				{...this.props}
			>

				<NSBoxString
					ref={this.NSBoxString_Key}
					title='Name'
					required
					onChanged={this.props.onChanged}
				/>
				<NSBoxString
					ref={this.NSBoxString_Value}
					title='Value'
					required={false}
					menu={{
						builtin: {
							delete: {
								enabled: true,
								onDelete: this.props.onDeleted ?? (() => { })
							}
						},
						items: []
					}}
					onChanged={this.props.onChanged}
				/>
			</NSRow>
		);
	}
}